export function ProductVisualImagesSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading generated images"
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    >
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className="overflow-hidden rounded-xl border border-border bg-card shadow-card"
        >
          <div className="aspect-square animate-pulse bg-muted" />

          <div className="space-y-3 p-4">
            <div className="h-4 w-2/3 animate-pulse rounded-full bg-muted" />

            <div className="h-3 w-1/3 animate-pulse rounded-full bg-muted" />

            <div className="h-5 w-1/2 animate-pulse rounded-full bg-muted" />
          </div>
        </div>
      ))}

      <span className="sr-only">Loading generated images…</span>
    </div>
  )
}
